/*
 * Объект - фасад для карт
 */
var mainMap = function (element) {
    //Массив точек на карте
    this.points = [];

    //Массив окон доступных для открытия на карте
    this.windows = [];

    this.container = $(element)[0];
    this.map = null;
    if (this.container) {
        this.map = new google.maps.Map(this.container, {
            center: new google.maps.LatLng(this._latCenter, this._lngCenter),
            zoom: this._startZoom,
        });
        this.map.setOptions({
            styles:this._styleMap,
            zoomControl: true,
            mapTypeControl: false,
            scrollwheel: false,
        });

        var self = this;
        $(this.container).bind('click', function () {
            self.map.setOptions({
                scrollwheel: true,
            });
        });
    }
};

/**
 * Устанавливает точку на карте
 * входящий параметр представляет собой объект JSON с двумя обязательными параметрами
 * lat и lng которые определяют широту и долготу соответственно, и параметр title
 * @param geoPoint
 */
mainMap.prototype.setPoint = function (geoPoint) {
    if(!geoPoint.title) {
        geoPoint.title='';
    }

    var point = new google.maps.Marker({
        position: {
            lat: geoPoint.lat,
            lng: geoPoint.lng,
        },
        title: geoPoint.title,
        icon: this._iconPoint,
    });
    point.setMap(this.map);
    this.points.push(point);
    return this.points.length-1;
};

//Устанавливает событие клика на точку с открытием окна
//index - идентификатор точки
//window - окно
mainMap.prototype.pointSetClickOnWindow = function (index, window) {
    var self = this;
    this.points[index].addListener('click', function () {
        self.windows.forEach(function (item){
            item.close();
        });
        window.open(self.map, self.points[index]);
    });
};

mainMap.prototype.createWindow = function (data) {
    var info = new google.maps.InfoWindow({
        content: data,
    });
    this.windows.push(info);
    return info;
};

//Удаляет точку скарты и из массива точек
//index номер точки в массиве
//если index не передан, удаляютсявсе точки
mainMap.prototype.deletePoint = function (index) {
    if (index) {
        var point = this.points[index];
        point.setMap(null);
        this.points.pop(index);
    } else {
        this.points.forEach(function(point){
            point.setMap(null);
            this.points = [];
        });
    }
    return true;
};

//Устанавливает центр карты в нужную точку
mainMap.prototype.setCenter = function (geoPoint) {
    this.map.panTo(new google.maps.LatLng(geoPoint.lat, geoPoint.lng));
    return true;
};

mainMap.prototype.setZoom = function (zoomIndex) {
    this.map.zoom = zoomIndex;
    return true;
};



//Координата широты центра карты (по умолчанию)
mainMap.prototype._latCenter = 62.26792263;
//Координата долготы центра карты (по умолчанию)
mainMap.prototype._lngCenter = 95.9765625;
//Начальный масштаб карты (по умолчанию)
mainMap.prototype._startZoom = 3;
//Стили карты (по умолчанию)
mainMap.prototype._styleMap = [
    {
        featureType: "all",
        stylers: [
            {
                saturation: -80,
            }
        ]
    },
    {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
            { hue: "#00ffee" },
            { saturation: 50 }
        ]
    }
];

//Точка на карте
mainMap.prototype._iconPoint = "/img/placeholder.png";